module.exports = __webpack_public_path__ + "img/car.6bb4ea65.svg";